import gradients from './gradients';
import shadows from './shadows';

const defaultEffectsExport = {
  gradients,
  shadows,
};

export default defaultEffectsExport;
